import {Injectable} from '@angular/core';

import {IonicSafeString} from "@ionic/angular";


import {ApiService} from "@services/api.service";
import {HttpService} from "@services/http/http.service";
import {StorageService} from "@services/storage/storage.service";
import {UiHelperService} from '@services/ui-helper/ui-helper.service';

import {appRoutingEnum} from "@enums/appRoutingEnum";

import {StandardResponse} from "@interfaces/general.types";

@Injectable({
  providedIn: 'root'
})
export class VideoCallService {
  public callAlertShow: boolean = false;
  public canMakeVideoCalls: boolean = false;
  public videoChat: any = null;
  public callAlert: any;
  public audioCall: any;
  public audioWait: any;
  private status: any;
  private lastCallId: any;

  constructor(
    private api: ApiService,
private http: HttpService,
    private storage: StorageService,
    private uiHelper: UiHelperService,
  ) {
    this.audioCall = new Audio();
    this.audioCall.src = 'https://m.richdate.co.il/phone_ringing.mp3';
    this.audioCall.loop = true;
    this.audioCall.load();
    this.audioWait = new Audio();
    this.audioWait.src = 'https://m.richdate.co.il/landline_phone_ring.mp3';
    this.audioWait.loop = true;
    this.audioWait.load();
    this.http.get(this.http.url + '/video/check').subscribe((status: any) => {
        this.canMakeVideoCalls = status.video;
    }, error => {
      this.canMakeVideoCalls = false;
    });
  }

  /**
   * This handles creating a video call from beginning to end. Play a ring,
   * present a toast to accept or reject a call, renderImagesToSendAsHtml a push to the receiver if necessary.
   * If accepted, we create an element to display the call and an element to exit it.
   * On back, we remove them both.
   * @param param - Data about the call, namely the receiver id, the unique chat id, and whether to play an showAlert.
   * @type {(param:{id:string, chatId: string, showAlert: boolean})=>{}
   */
  openVideoChat(param: { id: string, chatId: string | number, alert: boolean, [key: string]: any }) {
    this.storage.getItem('user_id').then((id) => {
      this.playAudio('call');
      this.http.post(this.http.url + '/user/call/' + param.id, {
        message: 'call',
        id: param.chatId
      }).subscribe((res: any) => {
          this.stopAudio();
          if (res.error != '') {
            this.uiHelper.presentToast({
              message: new IonicSafeString(res.error),
              buttons: [{
                text: 'אישור',
                role: 'cancel',
                handler: () => this.uiHelper.dismissToast()
              }]
            });
          } else {
            if (res.call.sendPush) {
              this.http.post(this.http.url + '/user/call/push/' + param.id, {}).subscribe((data: any) => {
              }, err => console.log(err))
            }
            param.chatId = res.call.msgId;
            const closeButton = this.createCloseVideoChatButton(param);
            this.createVideoIframe(id as string, param);
            document.body.appendChild(this.videoChat);
            document.body.appendChild(closeButton);
            if (param.alert == false) {
              this.checkVideoStatus(param);
            }
          }
        }, error => {
          console.log(error)
          this.stopAudio();
        }
      )
    })
  }

  playAudio(audio:any) {
    if (this.callAlertShow == false) {
      // this.uiHelper.presentLoader();
    }
    if (audio == 'call') {
      this.audioCall.play();
      this.audioCall.loop = true;
    } else {
      this.audioWait.play();
      this.audioWait.loop = true;
    }
  }

  stopAudio() {
    this.audioCall.pause();
    this.audioCall.currentTime = 0;
    this.audioWait.pause();
    this.audioWait.currentTime = 0;
    this.uiHelper.hideLoader();
  }

  checkVideoStatus(param:any) {
    this.http.get(this.http.url + '/user/call/status/' + param.chatId).subscribe((res: any) => {
      this.status = res.status;
      //call answered
      if (res.status == 'answer') {
      }
      //call rejected or cannot be taken
      if (res.status == 'close' || res.status == 'not_answer') {
        this.stopAudio();
        if (this.videoChat != null || this.callAlert != null) {

          this.uiHelper.presentToast({
            message: (this.status == 'not_answer' && this.videoChat && true) ? ('השיחה עם ' + param.username + ' נדחתה') : 'השיחה הסתיימה',
            buttons: [{text: 'אישור', role: "cancel"}]
          });
        }
        if (this.callAlert) {
          this.callAlert.dismiss();
          this.callAlert = null;
        }
        if (this.videoChat) {
          this.removeHtmlElements('#back-btn,#video-iframe');
          this.videoChat = null;
        }
      }

      // still waiting for response
      if (this.videoChat != null || this.callAlert != null) {
        setTimeout(() => {
          this.checkVideoStatus(param)
        }, 3000);
      }
    });
  }

  /**
   * @param param
   * @private
   * @type {(param: {chatId: string})=>HTMLButtonElement}
   */
  private createCloseVideoChatButton(param: { chatId: string | number, id: string }): HTMLButtonElement {
    this.removeHtmlElements('#back-btn,#video-iframe');
    const closeButton:any = document.createElement('button');
    closeButton.setAttribute('id', 'back-btn');
    closeButton.style.backgroundColor = 'transparent';
    closeButton.style.margin = '0 10px';
    closeButton.style.width = '40px';
    closeButton.style.height = '40px';
    closeButton.style['font-size'] = '0px';
    closeButton.style['text-align'] = 'center';
    closeButton.style.background = 'url(assets/img/video/buzi_b.png) no-repeat center';
    closeButton.style['background-size'] = '100%';
    closeButton.style.position = 'absolute';
    closeButton.style.bottom = '10px';
    closeButton.style.left = 'calc(50% - 25px)';
    closeButton.style.zIndex = '9999';
    closeButton.onclick = (e:any) => {
      this.removeHtmlElements('#back-btn,#video-iframe')
      this.http.post(this.http.url + '/user/call/' + param.id, {
        message: 'close',
        id: param.chatId
      }).subscribe((data: any) => {
      });
      this.videoChat = null;
    };
    return closeButton;
  }

  /**
   * @param id
   * @param param
   * @private
   * @type {(id:string, param:{id:string})=>HTMLIFrameElement}
   */
  private createVideoIframe(id: string, param: { id: string }): HTMLIFrameElement {
    this.videoChat = document.createElement('iframe');
    this.videoChat.setAttribute('id', 'video-iframe');
    this.videoChat.setAttribute('src', 'https://m.richdate.co.il/video.html?id=' + id + '&to=' + param.id);
    this.videoChat.setAttribute('allow', 'camera; microphone');
    this.videoChat.style.position = 'absolute';
    this.videoChat.style.top = '0';
    this.videoChat.style.left = '0';
    this.videoChat.style.boxSizing = 'border-box';
    this.videoChat.style.width = '100vw';
    this.videoChat.style.height = '101vh';
    this.videoChat.style.backgroundColor = 'transparent';
    this.videoChat.style.zIndex = '999';
    this.videoChat.style['text-align'] = 'center';
    return this.videoChat;
  }

  /**
   * "Give me a selector, and I will remove the world" - Archimedes, probably
   * @param selector - A css selector for the elements we wish to remove.
   * @type {(selector: string)=> void}
   */
  removeHtmlElements(selector:any) {
    document.querySelectorAll<HTMLElement>(selector).forEach((elem) => elem.remove());
  }

  async incomingCallAlert(data:any) {
    if (this.callAlertShow == false && this.videoChat == null) {
      this.playAudio('wait');
      this.callAlertShow = true;
      const param = {
        id: data.calls.msgFromId,
        chatId: data.calls.msgId,
        alert: true,
        username: data.calls.nickName,
      };
      this.checkVideoStatus(param);
      this.callAlert = await this.api.alertCtrl.create({
        message: new IonicSafeString('<img class="showAlert-call" width="40" src="' + data.calls.img.url + '"> ' + data.calls.title),
        buttons: [
          {
            text: data.calls.buttons[1],
            cssClass: 'redCall',
            role: 'cancel',
            handler: () => {
              this.lastCallId = data.calls.msgId;
              this.stopAudio();
              this.callAlertShow = false;
              this.http.post(this.http.url + '/user/call/' + param.id, {
                message: 'close',
                id: param.chatId
              }).subscribe((data: any) => {
                if (this.callAlert !== null) {
                  this.callAlert.dismiss();
                  this.callAlert = null;
                }
                setTimeout(() => {
                  this.lastCallId = null;
                }, 3000);
              });
            }
          },
          {
            text: data.calls.buttons[0],
            cssClass: 'greenCall',
            handler: () => {
              if (this.callAlert !== null) {
                this.callAlert.dismiss();
                this.callAlert = null;
              }
              this.callAlertShow = false;
              this.openVideoChat(param);
            }
          }
        ]
      });

      await this.callAlert.present();
      this.callAlert.onWillDismiss(() => {
        this.callAlertShow = false;
        this.callAlert = null;
        this.stopAudio();
      });
    }
  }

  getCalls() {
    if (this.api.pageName != appRoutingEnum.SUBSCRIPTION) {
      this.http.get(this.http.url + '/user/call/get').subscribe((data: any) => {
        if (this.videoChat == null && data.calls) {
          if (this.lastCallId == null || this.lastCallId != data.calls.msgId) {
            this.incomingCallAlert(data).then();
          }
        }
      });
    }
  }
}
